import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GoogleAnalyticsEvent } from '../model/google-analytics-event';

declare let gtag;
declare global {
  interface Window {
    dataLayer: any; // 👈️ turn off type checking
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor(public router: Router) {}

  /** UA Methods */

  /**
   * Sends an event to Google Analytics
   * @param event is an object containing the info to send
   */
  sendEvent(event: GoogleAnalyticsEvent): void {
    gtag('event', event.name, {
      event_category: event.category,
      event_label: event.label,
      event_action: event.action,
      event_value: event.value
    });
  }

  /**
   * Sends multiple events to Google Analytics
   * @param events is an array of objects containing the events to send
   */
  sendMultipleEvents(events: GoogleAnalyticsEvent[]): void {
    events.forEach((event) => {
      gtag('event', event.name, {
        event_category: event.category,
        event_label: event.label,
        event_action: event.action,
        event_value: event.value
      });
    });
  }

  /**
   * Sends page view data to Google Analytics when a route change occurs
   * @param googleId is a string containing the Google Analytics id from your gtag
   * TODO: this code will deprecate once all applications are moved to GA4
   */
  initializePageViewTracking(googleId: string): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event && event.urlAfterRedirects) {
          gtag('config', googleId, { page_path: event.urlAfterRedirects });
        }
      });
  }

  /** GA4 Methods */

  /**
   * Sends a custom event to Google Analytics 4 via GTM
   * @param event is an object containing the info to send
   */
  sendCustomEvent(event: GoogleAnalyticsEvent): void {
    if (event) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event.name,
        category: event.category,
        action: event.action,
        label: event.label,
        value: event.value
      });
    }
  }

  /**
   * Sends page view data to Google Analytics 4 via GTM when a route change occurs
   */
  initializeVirtualPageViewTracking(): void {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event && event.urlAfterRedirects) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'virtual_page_view',
            page_path: event.urlAfterRedirects
          });
        }
      });
  }
}
